import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-news-card-gnu',
  templateUrl: './news-card-gnu.component.html',
  styleUrls: ['./news-card-gnu.component.scss']
})
export class NewsCardGnuComponent implements OnInit {

  @Input('title') title: string;
  @Input('image') image: string;
  @Input('date') date: Date;
  @Input('link') link: string;


  constructor() { }

  ngOnInit(): void {
  }

}
